/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

import { Badge } from '@/components/ui/badge';

interface TokenBadgeProps {
  tokens: number;
  showLabel?: boolean;
}

export function TokenBadge({ tokens, showLabel = true }: TokenBadgeProps) {
  // Format token count
  let formatted: string;
  if (tokens >= 1000) {
    formatted = `${(tokens / 1000).toFixed(1)}k`;
  } else {
    formatted = tokens.toString();
  }

  return (
    <Badge variant="outline" className="text-xs bg-gray-50 text-gray-600 border-gray-200">
      {formatted} {showLabel && 'tokens'}
    </Badge>
  );
}
